export enum EmbedShowType {
    LOAD_READY = 'LOAD_READY',
    CLICK_LINK = 'CLICK_LINK',
}

export enum EmbedType {
    NO_ID = 'NO_ID',
    INTERNAL_ID = 'INTERNAL_ID',
    EXTERNAL_ID = 'EXTERNAL_ID',
}

export interface Embed {
    embedShow: EmbedShowType;
    embedLinkName: string;
}

export const initialEmbed: Readonly<Embed> = {
    embedShow: EmbedShowType.LOAD_READY,
    embedLinkName: 'Примите участие в опросе',
};
